<template>
  <section id="hero-forms" class="bg--scroll hero-section">
    <div class="container color--white">
      <div class="row justify-content-center">
        <div class="col-lg-11 col-xl-10">
          <div class="inner-page-title mt-10 pt-15">
            <h2 class="s-52 w-700">{{ bannerTitle }}</h2>
          </div>
        </div>
      </div>
    </div>
    <!-- End container -->
    <!-- WAVE SHAPE BOTTOM -->
    <div class="wave-shape-bottom">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 290">
        <path
          fill-opacity="1"
          d="M0,256L120,250.7C240,245,480,235,720,224C960,213,1200,203,1320,197.3L1440,192L1440,320L1320,320C1200,320,960,320,720,320C480,320,240,320,120,320L0,320Z"
        ></path>
      </svg>
    </div>
  </section>
</template>
<script lang="ts">
export default defineComponent({
  name: "ComponentsFormsQuoteStart",
  props: {
    bannerTitle: {
      type: String as () => string,
      default: () => "Instant quote",
    },
  },
});
</script>
  